import {SharedModule} from '../shared/shared.module';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { LoginModule } from '../login/login.module';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AssessmentsRoutingModule } from './assessments-routing.module';
import { AssessmentsComponent } from './assessments/assessments.component';
import { TakeAssessmentComponent } from './take-assessment/take-assessment.component';
import { QuestionSetComponent } from './question-set/question-set.component';
import { QuestionComponent } from './question/question.component';
import { QuestionDropdownComponent } from './question-dropdown/question-dropdown.component';
import { ThemeModule } from "../theme/theme.module";
import { TakeAssignmentComponent } from './take-assignment/take-assignment.component';
import { AssessmentComponent } from './assessment/assessment.component';
import { QuestionTextboxComponent } from './question-textbox/question-textbox.component';
import { QuestionChecklistComponent } from './question-checklist/question-checklist.component';
import { QuestionSingleCheckboxComponent } from './question-single-checkbox/question-single-checkbox.component';
import { ReportsModule } from '../reports/reports.module';
import { AssessmentSingleQuestionDisplayComponent } from './assessment-single-question-display/assessment-single-question-display.component';
import { QuestionListItemComponent } from './question-list-item/question-list-item.component';
import { LibraryAssetsModule } from 'app/library-assets/library-assets.module';
import { TakeAssetExternalComponent } from './take-asset-external/take-asset-external.component';

@NgModule({
  imports: [
    CommonModule
    ,FormsModule
    ,RouterModule
    ,LoginModule
    ,ThemeModule
    ,SharedModule
    ,ReportsModule
    ,LibraryAssetsModule
    ,AssessmentsRoutingModule
  ],
  declarations: [DashboardComponent, AssessmentsComponent, TakeAssessmentComponent, QuestionSetComponent, QuestionComponent, QuestionDropdownComponent, TakeAssignmentComponent, AssessmentComponent, QuestionTextboxComponent, QuestionChecklistComponent, QuestionSingleCheckboxComponent, AssessmentSingleQuestionDisplayComponent, QuestionListItemComponent, TakeAssetExternalComponent ],
  providers: []
})
export class AssessmentsModule { }




// WEBPACK FOOTER //
// ./src/app/assessments/assessments.module.ts